import { fileAuthApi } from '../../api';

export const download = async (guid: string) => {
  const response = await fileAuthApi.get(`/user-document/${guid}/download`);

  return response.data;
};
